(function () {
  if (window.BottleBuddyCartSyncV6) return;
  window.BottleBuddyCartSyncV6 = true;

  var syncTimer = null;
  var isSyncing = false;

  function getCartUrl(path) {
    if (window.Theme && window.Theme.routes) {
      if (path === 'update' && window.Theme.routes.cart_update_url) return window.Theme.routes.cart_update_url;
    }
    return path === 'update' ? '/cart/update.js' : '/cart.js';
  }

  function getSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map(function (component) { return component.dataset.sectionId; })
      .filter(Boolean)
      .filter(function (value, index, array) { return array.indexOf(value) === index; });
  }

  function getProperty(item, propertyName) {
    if (!item || !item.properties) return '';

    if (Array.isArray(item.properties)) {
      var found = item.properties.find(function (property) {
        return property && property[0] === propertyName;
      });
      return found ? found[1] : '';
    }

    return item.properties[propertyName] || '';
  }

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncOrphanGifts, 450);
  }

  async function syncOrphanGifts() {
    if (isSyncing) return;

    isSyncing = true;

    try {
      var cartResponse = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });

      if (!cartResponse.ok) return;

      var cart = await cartResponse.json();
      var groups = {};

      cart.items.forEach(function (item) {
        var groupId = getProperty(item, '_bundle_group');
        if (!groupId) return;

        if (!groups[groupId]) {
          groups[groupId] = {
            mainQuantity: 0,
            requiredMainQuantity: 0,
            gifts: []
          };
        }

        var group = groups[groupId];
        var role = getProperty(item, '_bundle_role');
        var isGift = role === 'gift' || getProperty(item, '_bundle_free_gift') === 'true';
        var isMain = role === 'main';
        var required = toNumber(getProperty(item, '_bundle_required_main_quantity'));

        if (required > group.requiredMainQuantity) {
          group.requiredMainQuantity = required;
        }

        if (isMain) {
          group.mainQuantity += Number(item.quantity || 0);
        }

        if (isGift) {
          group.gifts.push(item);
        }
      });

      var updates = {};

      Object.keys(groups).forEach(function (groupId) {
        var group = groups[groupId];
        var isBrokenBundle = group.mainQuantity <= 0;

        if (group.requiredMainQuantity > 0 && group.mainQuantity < group.requiredMainQuantity) {
          isBrokenBundle = true;
        }

        if (!isBrokenBundle) return;

        group.gifts.forEach(function (giftItem) {
          if (giftItem.key) updates[giftItem.key] = 0;
        });
      });

      if (!Object.keys(updates).length) return;

      var sectionIds = getSectionIds();
      var payload = {
        updates: updates,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      };

      var updateResponse = await fetch(getCartUrl('update'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      });

      var updatedCart = await updateResponse.json();

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: updatedCart,
            sourceId: 'bottle-buddy-cart-sync',
            data: {
              source: 'bottle-buddy-cart-sync',
              itemCount: updatedCart.item_count,
              sections: updatedCart.sections || {}
            }
          }
        })
      );
    } catch (error) {
      console.error('Bottle Buddy cart sync failed:', error);
    } finally {
      isSyncing = false;
    }
  }

  document.addEventListener('cart:update', function (event) {
    var detail = event && event.detail ? event.detail : {};
    var data = detail.data || {};

    if (data.source === 'bottle-buddy-cart-sync' || detail.sourceId === 'bottle-buddy-cart-sync') return;

    scheduleSync();
  });

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('.cart-items__remove, [on\\:click^="/onLineItemRemove"]')) {
      scheduleSync();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('cart-quantity-selector-component, .cart-items__quantity')) {
      scheduleSync();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();
